import { TBaseItem } from "@centricsoftware/design-system";
import { INVALID_PROPERTY } from "csi/store/common";
import { NamesResult, StoreNames } from "csi/store/Names";
import { IAggregateStoreResult } from "src/c8-platform/type/aggregateStore";
import { ATTR_NAME } from "src/c8-platform/type/node";
import { cnl } from "src/c8-platform/type/value";
import { convertNamesStoreDataToItems } from "./selectUtility";

/** query the aggregate store for the form field */
export async function queryAggregateStoreForSelect(aggregateStore: StoreNames, setErrorText?: (text: string) => void): Promise<{
	options: TBaseItem[];
	invalidItems: IAggregateStoreResult[];
}> {
	let options: TBaseItem[] = [];
	let invalidItems: IAggregateStoreResult[] = [];
	let data: NamesResult[];
	try {
		data = await aggregateStore.asyncQuery(null, { noActionData: true } as dojo.store.api.QueryOptions);
	} catch (err) {
		console.error(err);
		setErrorText?.(err.message);
	} finally {
		if (data) {
			// convert store data to component items
			options = convertNamesStoreDataToItems(data, aggregateStore);
			const { labelProperty } = aggregateStore;
			const items = Array.from(data);
			invalidItems = items
				.filter((item) => !!item[INVALID_PROPERTY])
				.map((item) => {
					const newItem = {
						$id: aggregateStore.getIdentity(item) as cnl,
						[ATTR_NAME]: item[labelProperty],
					};
					return newItem;
				});
		}
	}
	return { options, invalidItems };
}